export const callOpenAI = async (prompt, systemInstruction = "") => {
    try {
        const response = await fetch('/api/chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt, systemInstruction })
        });

        if (response.status === 404) throw new Error("Backend_Not_Found: Cloudflare Functions 尚未就緒");
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `Server Error: ${response.status}`);
        }
        const data = await response.json();
        return data.result || "";
    } catch (error) {
        console.error("AI Service Error:", error);
        throw error;
    }
};
